import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import locale from 'locale';
import routes from 'config/routes';
import type { Column } from 'components/lib/Table/types';
import type LeaveType from 'types/leaveType';

import useNavStore from 'stores/useNavStore';
import { fillRouteParam } from 'utils';

import Button from 'components/lib/Button';
import EditPen, { Wrapper as _EditPen } from 'components/svg/EditPen';
import Trash, { Wrapper as _Trash } from 'components/svg/Trash';

const ActionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 13rem;

  ${_EditPen}, ${_Trash} {
    height: 22rem;
    cursor: pointer;
  }
`;

export default (openDelLeaveTypeModal: (d: LeaveType) => void) => {
  const navigate = useNavStore(state => state.navigate);

  const [columns, setColumns] = useState<Column<LeaveType>[]>([]);

  const handleNewClick = () => {
    const route = routes.settings.routes!.leaveType!.routes!.new!;
    navigate && navigate(route);
  }

  const handleEditClick = (r: LeaveType) => {
    const route = routes.settings.routes!.leaveType!.routes!.edit!;

    if (navigate && route.render && r.id) {
      const url = fillRouteParam(
        route.render.url,
        [{ param: 'id', value: r.id }]
      );

      navigate(route, url);
    }
  }

  useEffect(() => {
    const columns: Column<LeaveType>[] = [
      {
        title: locale.en.settings.leaveType.table.name,
        render: r => r.name
      },
      {
        title: locale.en.settings.leaveType.table.status,
        render: r => r.status === "active" ? "Active" : "Not Active"
      },
      {
        title: (
          <Button.Ghost onClick={handleNewClick}>
            {locale.en.common.button.new}
          </Button.Ghost>
        ),
        width: "100rem",
        style: { justifyContent: "end" },
        render: r => (
          <ActionCell className={r.deleteAble === false ? "disabled-icon" : ""}>
            <EditPen onClick={() => handleEditClick(r)} />
            <Trash onClick={() => openDelLeaveTypeModal(r)} />
          </ActionCell>
        )
      }
    ];

    setColumns(columns);
  }, []);

  return columns;
}